export function caseDate() {
  return [
    {
      parentId: "02",
      type: "园区",
      id: "0201",
      productName: "智慧园区",
      msg: "协助企业实现全面安全防护和风险管控，平台支持硬件设备接入，实现智能化感知、联网管理、数据分析。为实现人员管理，数据自动推送至公安网进行人员实名认证，配合公安完成流口人员登记，精细人员管控，提升企业管理效率，创造平安营商环境。",
      urlId: "id_02_01",
    },
    {
      parentId: "06",
      type: "政府",
      id: "0601",
      productName: "数字政工会议系统",
      msg: "线上重塑会议管理全流程应用，提供会务管理、议题管理、电子文档多样化适配阅览等能力，为学校、企业、机关等提供等电子化、安全化、留痕化会议管理服务。",
      urlId: "id_06_01",
    },
    {
      parentId: "06",
      type: "政府",
      id: "0602",
      productName: "党建云留痕平台",
      msg: "提供数字化党建解决方案，对党建工作中涉及的日常学习、党群活动、组织管理、民主测评等环节，实现全面的线上留痕。构建可视化、可定义的激励机制，推动党建工作走向规范化、便捷化。",
      urlId: "id_06_02",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0101",
      productName: "纠纷调解智治系统",
      msg: "贯通政法、公安、信访、司法等多个部门，打通矛盾纠纷数据分离壁垒，建立矛盾纠纷风险精准分析模型，协同网格、民警、乡贤进行分流处置，构建处置闭环，长效跟踪矛盾纠纷化解成效，实现基层减负、化解彻底的双向提升。",
      urlId: "id_01_01",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0102",
      productName: "智控精防系统",
      msg: "汇聚精神障碍患者底数，建立分级管控规范，一对一关联“六人小组”，引入24小时全天候的家庭监护上报机制，落实监护人的感知、监护责任；建立健全日常走访、管控预警的工作闭环，形成可视化、可导出的工作台账。",
      urlId: "id_01_02",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0103",
      productName: "美丽乡镇共治平台",
      msg: "围绕“一屏观全域，一网管全镇”理念，建设美丽乡镇共治大屏，通过对乡镇个性化产业的挖掘和适配，建立包括规划地图、产业提升、综治维稳、党建引领等多个子领域的管理应用，针对性打造智慧渔业、智慧文旅等子场景，形成乡镇建设整体视图，辅助决策与产业提升。",
      urlId: "id_01_03",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0104",
      productName: "公益云平台",
      msg: "建立公安后台指挥，义警前端响应的应用体系，提供义警备案、实时定位、活动发起及响应、警务信息公告、宣传防范等实用功能。",
      urlId: "id_01_04",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0105",
      productName: "景区协同智管平台",
      msg: "构建面向管理者和游客的综合管理应用，通过建立多维立体的景区3维实景地图，建立动态的人流、车流及各类要素的实时监测与预警模型，配套健全报警调度响应、交通引导、态势评估、停车预约等服务应用，形成景区管理应用生态。",
      urlId: "id_01_05",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0106",
      productName: "“护苗”未成年保护平台",
      msg: "基于未成年人帮扶管理、青少年案事件发案现状等实际治理痛难点，通过贯通政府、社会团体、学校、家庭，打造未成年人帮扶管理的全流程应用。<br>建设“护苗”驾驶舱，对问题少年、迷茫少年、困境少年三类人员重点浙里办、平台端等多端的家校联动应用、未成年人异动预警模型、未成年人矫正应用等应用体系。",
      urlId: "id_01_06",
    },
    {
      parentId: "01",
      type: "综治",
      id: "0107",
      productName: "创新指数e贷",
      msg: "通过对接外部科创指数评估体系,构建起企业科创信息采集、模型计算、授信额度匹配和银行对接的在线智能信贷服务平台,实现了企业的线上融资申请、银行额度授信审批、放款管理的全流程融合和优化,帮助企业获得关联科创要素的智能评估、在线授信和快速融资。",
      urlId: "id_01_07",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0401",
      productName: "“一标三实”社会治理平台",
      msg: "建设前端核采应用，中端分析引擎，后端共享数据池的完整应用体系，实现对标准地址、实有人口、实有房屋、实有单位的精准核采和关联，支撑人口管理、重点人员防控、行业管理等多种公安业务，同步赋能其他业务。",
      urlId: "id_04_01",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0402",
      productName: "防控治理警务综合平台",
      msg: "建设人地事物单位行业等7个标准数仓，规范基础警务触警流程，建立重点人员预测预警N个模型、省市县集成任务中心、专项治理模块、全域智控管理、绩效晾晒驾驶舱等多个应用，打造成为治安部门主干业务平台。",
      urlId: "id_04_02",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0403",
      productName: "重点人员管控预警平台",
      msg: "贯通省市县三级重点人员底数，支撑平战时结合的重点人员管控，平时管控侧重流程闭环，通过建设完整的人员分级、管控配置、反馈应用等实现闭环；战时管控侧重风险发现，梳理各级公安内高频共性需求建立一批如聚集、脱圈、外来流动、高危滞留等人员发现和监测预警模型，对高危风险出现、预防提供支撑。",
      urlId: "id_04_03",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0404",
      productName: "出租房屋“安全管家”平台",
      msg: "围绕“居住出租房屋旅馆式管理”模式，建设出租房屋标准化入库，星级式管理、流动人口旅住快速登记的新型流动人口管理模式，配套建设“房东码”等应用，推动房东主动参与人口登记和房屋管理，延伸拓展向就业保障、在线寻租等多个服务、治理场景，建成“新市民安家全流程安全管家”。",
      urlId: "id_04_04",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0405",
      productName: "“掌上办”警务办公应用",
      msg: "依托浙政钉应用，集成公安内部各类审批流程，提供流程自定义、进度智能跟踪等配套能力，节约公安部门内部跑腿耗时，提升办事效率，实现“数字跑腿”，“办事跑0次”。",
      urlId: "id_04_05",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0406",
      productName: "警务“共创”论坛",
      msg: "服务公安“双师”（情报分析师、数据建模师）创建需求，基于“数据魔方”、“数据乐高”等建模平台，配套建设集任务发布、需求分析、揭榜认领、模型分析、模型共享、综合评价等全流程功能为一体的共创平台，直接服务于公安各类业务，加快公安内部的技术进步、能力提升。",
      urlId: "id_04_06",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0407",
      productName: "码上警务云平台",
      msg: "依托支付宝/微信等实名能力，构建“一人一码，扫码快采”的新型警务应用，改革公安巡逻登记、设卡盘查、场所检查等业务工作模式。延伸拓展向场所管理、访客管理等社会治理层面，支持无感通行登记、场所自主管理等多个场景。",
      urlId: "id_04_07",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0408",
      productName: "移车宝应用",
      msg: "移车宝应用实现车辆管理和社会治安维护。移车宝通过车牌识别快速获取车辆信息,并按车牌号向车主发送短信通知车辆变动。同时,应用还支持通过外呼系统电话联系车主,传递重要信息。移车宝实现实时通知和人性化沟通,大大提高车辆管理和应急处置的效率。它为公安提供精准、高效的技术支持,增强社会治安维护能力。",
      urlId: "id_04_08",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0409",
      productName: "警情“日清月结”工作系统",
      msg: "针对警情处置流程进行监督，建立“一警一档”数字台账，面向民警、上级领导等多层级提供警情在线处置、警情关注跟踪、处置督导管理、整改监测等闭环能力，实现警情全流程的规范化、高效化分析。",
      urlId: "id_04_09",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0410",
      productName: "警情标签化处置平台",
      msg: "通过对已有警情进行细化拆分和标签化管理，完善警情打标审核流程，建立健全警情打标的个性化定义中心，支持在订阅中心中进行标签模型的建设、共享、订阅。通过警情的标签化拆分和分析，推动警情在公安警力调配、工作计划制定等方面的赋能能力提升。",
      urlId: "id_04_10",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0411",
      productName: "警银联动杆“安卡宝”平台",
      msg: "推动公安、银行等多部门联动治理机制的成熟与落地，开卡全流程闭环，对“两卡”黑灰产犯罪的源头阻断、协同治理，在电信诈骗止付环节实现事前干预和止损。",
      urlId: "id_04_11",
    },
    {
      parentId: "04",
      type: "公安",
      id: "0412",
      productName: "“三能”积分指数平台",
      msg: "通过对民警职业全生命周期管理赋分，将工作得失、效能高下、隐患多少全面直观展示于一处，既也为干部民警评先评优、提拔任用、岗位调整、职级晋升提供了科学依据，更能倒逼科所队和民警提能增效、争先进位，从而实现向数据要警力、向数据要决策力、向数据要战斗力的效果。",
      urlId: "id_04_12",
    },
    {
      parentId: "07",
      type: "司法",
      id: "0701",
      productName: "诉讼失信治理平台",
      msg: "围绕诉讼失信人员打造共管共治的统一信用监督体系，通过数据贯通明确失信底数，通过部门业务贯通实现人员协同管理，健全信用评级、信用修复等流程应用，倒逼诉讼失信人员及时修复信用，减少司法资源、行政资源浪费。",
      urlId: "id_07_01",
    },
    {
      parentId: "07",
      type: "司法",
      id: "0702",
      productName: "智慧审监平台",
      msg: "提供省域民事案件可视化审查能力，助力司法公平，辅助决策监督。",
      urlId: "id_07_02",
    },
    {
      parentId: "05",
      type: "教育",
      id: "0501",
      productName: "教师课程平台",
      msg: "提供在线教育的课程管理、教师管理等配套应用，可支撑在线教育的课程安排、教师分配等管理需求。",
      urlId: "id_05_01",
    },
    {
      parentId: "05",
      type: "教育",
      id: "0502",
      productName: "高校科技成果转移转化平台",
      msg: "针对高校科技成果难转化问题，串联政府、银行等多部门，建立科技成果库，完善校企需求对接链条，健全专家咨询、人才检索、科技成果智能推送等应用能力，通过成果供给清单、企业需求清单两张清单的周期比对，推动成果落地，辅助高校、政府对科研方向、政策激励方向的决策调整。",
      urlId: "id_05_02",
    },
  ];
}

// 获取大类的文字描述
export function getParentObj() {
  let _obj = caseDate(),
    _result = {},
    _text = {
      "01": "以数字化手段兼顾多元主体，共同赋能社会治理",
      "02": "数字助推产业集聚，共建共享智能园区",
      // "03": "创新数智引导，推动四链融合，助力金融强国",
      "04": "用科技强警力，用数字提战力，助推警务现代化",
      "05": "数字赋能科教，科教振兴发展",
      "06": "智慧数字政府，让治理更高效，服务更亲民",
      "07": "打造智能司法运用场景，提升司法效能",
    };
  for (let i in _text) {
    let _name = _obj.filter((v) => v.parentId == i)[0].type;
    _result[i] = {
      name: _name,
      text: _text[i],
    };
  }
  return _result;
}
